"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosErrorParse = void 0;
/**
 * Takes a try / catch block where the try block has an axios call as an obvious potential fail point.
 * Attempts to parse error in catch block to provide a more detailed reason for failure.
 */
function AxiosErrorParse(err) {
    // Error
    if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return { success: false, error: err.response.data.message };
    }
    else if (err.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        return {
            success: false,
            error: "No response from server. Please contact the system administrator or try again later"
        };
    }
    else {
        // Something happened in setting up the request that triggered an Error
        return {
            success: false,
            error: "Request unable to be sent. Please contact the system administrator or try again later."
        };
    }
}
exports.AxiosErrorParse = AxiosErrorParse;
//# sourceMappingURL=AxiosErrorParse.utils.js.map